import { render, staticRenderFns } from "./tutorial-video.vue?vue&type=template&id=38e54423&scoped=true"
import script from "./tutorial-video.vue?vue&type=script&lang=ts"
export * from "./tutorial-video.vue?vue&type=script&lang=ts"
import style0 from "./tutorial-video.vue?vue&type=style&index=0&id=38e54423&prod&lang=scss&scoped=true"
import style1 from "./tutorial-video.vue?vue&type=style&index=1&id=38e54423&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e54423",
  null
  
)

export default component.exports